export const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, "");
